import TextField from "../../../../../components/fields/textField/TextField.vue";
import SelectField from "../../../../../components/fields/selectField/SelectField.vue";
import PeriodoField from "../../../../../components/fields/periodoField/PeriodoField.vue";
import TextAreaField from "../../../../../components/fields/textAreaField/TextAreaField.vue";
import FileInputField from "../../../../../components/fields/file-input-field/FileInputField.vue";
import { SnackBarModule } from "../../../../../modules/SnackBarModule";
import moment from "moment";

import { AgendarFeriasCivilService } from "../../../../../services/AgendarFeriasCivilService.js";
import { FeriasService } from "../../../../../services/FeriasService";
import { SolicitarFeriasService } from "../../../../../services/SolicitarFeriasService";

import {
  tipoReprogramacaoEnum
} from "../../../../../constants";
export default {
  name: "ReprogramarInterromperFerias",

  props: {
    options: {
      type: Array,
      required: true,
    }
  },

  components: {
    TextField,
    SelectField,
    PeriodoField,
    TextAreaField,
    FileInputField
  },

  beforeMount() {
    this.initializeForm();
  },

 
  data: () => ({
    unidadeLotacao:null,
    dataParcela: [],
    exercicio:null,
    civil: null,
    tipoCivil:null,
    parcela: null,
    subtituloExercicio: "Por favor selecione um exercício",
    form: {},
    formInterromper:{},
    loading: {
      field: false,
      btn: false,
    },
    disabled: false,

  }),



  computed: {
    enumtipoReprogramacao() {
      return tipoReprogramacaoEnum;
    }
  },

  watch: {
    unidadeLotacao: async function(unidade_id){
      await this.pegarPessoasPorUnidadeComFerias(unidade_id);
      this.$forceUpdate()
    },
    civil: async function(pessoa_id){
       this.pegarGraduacaoPorPessoa(pessoa_id);
       this.pegarTipoCivilPorPessoa(pessoa_id);
       await this.pegarExercicioPorPessoa(pessoa_id);

      this.$forceUpdate()
    },
    exercicio: async function(exercicio){
      this.pegarDiasPendentesDaPessoa(exercicio,this.civil);
      await this.pegarParcelasDaPessoa(exercicio, this.civil);
      this.$forceUpdate()
    },
    parcela: function(parcela){
      this.formInterromper.dataInicio = this.dataParcela[parcela].dataIni
      this.formInterromper.dataFim = this.dataParcela[parcela].dataFim
      // this.formInterromper.dataIni = this.dataParcela[parcela].dataIni
    }
  },

  methods: {
 


    initializeForm() {
      this.options.parcelas = []
  
      this.formInterromper = {
        idFerias: null,    
        dataInicio: null,
        dataFim: null,

        dataInicioNovoPeriodo: null,
        dataFimNovoPeriodo: null,
        numeroDiasNovoPeriodo: null,

        numeroDiasCorridos:null,

        exercicio: null,
    
        tipoReprogramacao:null,

        data: null,
        anexo: null

      }
    },

    async pegarPessoasPorUnidadeComFerias(unidade_id){
      const response = await AgendarFeriasCivilService.pegarPessoasPorUnidadeComFerias(unidade_id);
      this.options.civis =  response.map(el => {
        return {
          text: el.nome,
          value: el.id,
        }
      });


      this.options.civis?.unshift({ text: "Selecione", value: "" })

      return this.options.civis;
    },
    async pegarGraduacaoPorPessoa(pessoa_id){
      const response = await AgendarFeriasCivilService.pegarGraduacaoPorPessoa(pessoa_id);
      this.options.postoGraduacao = response[0].graduacao
      return;
    },
    async pegarDiasPendentesDaPessoa(exercicio,pessoa_id){
      const response = await AgendarFeriasCivilService.pegarDiasPendentesDaPessoa(exercicio,pessoa_id);
      this.form.numeroDias = response

      this.subtituloExercicio = `Você possui um saldo de ${response.dias} dia(s) no exercício ${exercicio}`

      return;
    },
    async pegarTipoCivilPorPessoa(pessoa_id){
      const tipoCivil = await AgendarFeriasCivilService.getTipoCivil(pessoa_id);
      this.tipoCivil = tipoCivil[0].tipo_civil
    },
    async pegarParcelasDaPessoa(exercicio,pessoa_id){
      const response = await AgendarFeriasCivilService.pegarParcelasDaPessoa(exercicio,pessoa_id);
 
      this.options.parcelas = response.map(el => {
        this.dataParcela[el.parcela] = {"dataIni": el.data_ini, 'dataFim': el.data_fin};
        return {
          text: el.parcela,
          value: el.parcela,
        }
      });

      this.options.parcelas?.unshift({ text: "Selecione", value: "" })


      return;
    },

    async pegarExercicioPorPessoa(pessoa_id){
      const response = await FeriasService.getExercicioPorMilitar(pessoa_id);
      this.options.exercicio = response.map(el => {
        return {
          text: el.ano,
          value: el.ano,
        }
      });
      this.options.exercicio?.unshift({ text: "Selecione", value: "" })

    },

    verificarCampos(){
      return this.formInterromper.tipoReprogramacao != this.enumtipoReprogramacao.NORMAL && this.formInterromper.tipoReprogramacao != null
    },


    prepareFormInterromper() {
        const formData = new FormData();
        formData.append("id_tipo_alteracao_alterar_periodo", this.formInterromper.reprogramarFerias);


        //formData.append("anexo", this.formInterromper.anexo);

        formData.append("idFerias", this.formInterromper.idFerias);
        formData.append("exercicio", this.formInterromper.exercicio);

        if(this.verificarCampos){
          formData.append("data_inicio", moment(this.formInterromper.data).format("YYYY-MM-DD"));
          formData.append("diasCorridos", this.formInterromper.numeroDiasCorridos);
          formData.append("arquivo", this.form.anexo);

        }else{
          formData.append("data_inicio", moment(this.formInterromper.dataInicioNovoPeriodo).format("YYYY-MM-DD"));
          formData.append("data_fim", moment(this.formInterromper.dataFimNovoPeriodo).format("YYYY-MM-DD"));
          formData.append("dias", this.formInterromper.numeroDiasNovoPeriodo);
        }

        this.saveFormInterromper(formData);

        
        return;
      
      //SnackBarModule("Campo(s) obrigatório(s) não informado(s).", "error");
    },

    async calculateDays() {
      if (this.formInterromper.dataInicioNovoPeriodo != null) {
        const formData = new FormData();
        formData.append("data_ini", moment(this.formInterromper.dataInicioNovoPeriodo).format("YYYY-MM-DD"));
        formData.append("dias", this.formInterromper.numeroDiasNovoPeriodo);
        const response = await SolicitarFeriasService.calcularDiasUteis(formData);
        this.formInterromper.dataFimNovoPeriodo = response.dataFim;
        this.formInterromper.numeroDiasNovoPeriodo = response.dias_uteis;
        return;
      }
      return SnackBarModule("Prencha o campo de data inicial", "error");
    },

    async saveFormInterromper(formData) {
      this.loading.btn = true;
      const response = await AgendarFeriasCivilService.interromperFerias(formData);
      this.loading.btn = false;
      if (response) {
        this.close();
      }
    },

    close() {
      this.initializeForm();
      this.$emit("on-close");
    },
  },
};